export const PERMISSIONS = {
  ADMIN: "admin",
  RECORDSWING: "recordswing",
  MANAGEOTHERSESSIONS: "manageothersessions",
  CANCOMPARETOOTHERSWINGS: "cancomparetootherswings"
} as const;